"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.IconList = function (_a) {
    var color = _a.color, style = _a.style;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 257 145", style: style },
        React.createElement("path", { fill: color, d: "M55 0h202v25H55zM0 0h25v25H0zM0 60h25v25H0zM0 120h25v25H0zM55 60h202v25H55zM55 120h202v25H55z" })));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/IconList.tsx
// module id = 309
// module chunks = 0